import { t } from "@/i18n-js/instance";
import { usePendingConnections } from "@/react/hooks/usePendingConnections";
import type { ExpandableAccordionItem } from "../shared/ExpandableAccordion";
import { ExpandableAccordion } from "../shared/ExpandableAccordion";

export const PendingConnections = () => {
  const pendingConnectionsQuery = usePendingConnections({
    perPage: 2,
  });
  const pendingConnections = pendingConnectionsQuery.audience || [];
  const hasMorePending = Boolean(pendingConnectionsQuery.hasNextPage);

  const items: ExpandableAccordionItem[] = pendingConnections.map(item => ({
    id: `${item.id}`,
    person: item,
    type: "connection",
  }));

  return (
    <ExpandableAccordion
      title={t("members_directory.grow.requests")}
      items={items}
      totalCount={pendingConnectionsQuery.totalQueryAudience ?? 0}
      isLoading={Boolean(pendingConnectionsQuery.isLoading)}
      hasMore={hasMorePending}
      fetchNextPage={() => pendingConnectionsQuery.fetchNextPage()}
      isFetchingNextPage={Boolean(pendingConnectionsQuery.isFetchingNextPage)}
      className="mx-2"
    />
  );
};
